<template>
  <div class="container">
    <div class="g-flex g-row-center white-bg g-p-b-30">
      <div class="total-width">
        <img src="@/assets/home/logo-blue-new.png" class="logo-icon g-p-t-30" />
        <div class="g-flex g-row-between">
          <div>
            <div class="g-flex">
              <img src="@/assets/home/phone.png" class="foot-ico" alt="">
              <p class="g-m-l-11 g-font-12">联系电话：138 1526 8850</p>
            </div>
            <div class="g-flex g-m-t-20">
              <img src="@/assets/home/email.png" class="foot-ico" alt="">
              <p class="g-m-l-11 g-font-12">邮箱：68803630@qq.com</p>
            </div>
            <div class="g-flex g-m-t-20">
              <img src="@/assets/home/position.png" class="foot-ico" alt="">
              <p class="g-m-l-11 g-font-12">公司地址：云南省昆明高新区海源中路汇金大厦商业广场B6-20A</p>
            </div>
          </div>
          <div class="g-flex">
            <div class="g-m-r-50">
              <p class="g-weight-font g-font-18">快速导航</p>
              <div class="g-flex sub-text g-font-14 g-m-t-20">
                <p class="pointer" @click="goPage('home')">首页</p>
                <p class="g-m-l-60 pointer"  @click="goPage('mine')">个人中心</p>
              </div>
              <div class="g-flex sub-text g-font-14 g-m-t-20">
                <p class="pointer"  @click="goPage('course-list')">课程</p>
                <p class="g-m-l-60 pointer" @click="goPage('examination')">考试</p>
              </div>
              <div class="g-flex sub-text g-font-14 g-m-t-20">
                <p class="pointer" @click="goPage('find-job')">找工作</p>
                <!-- <p class="pointer" :class="!getLoginState||!isClinic?'g-m-l-48':''" @click="goPage('find-careers')" v-if="!skipCareers">人才库</p> -->
              </div>
            </div>
            <div class="g-m-l-80">
              <p class="g-weight-font g-font-18">快捷入口</p>
              <p class="sub-text g-font-14 g-m-t-20" @click="goPage('login',{tabIndex:1})">登录</p>
              <p class="sub-text g-font-14 g-m-t-20" @click="goPage('login',{tabIndex:2})">注册</p>
              <!-- <p class="sub-text g-font-14 g-m-t-20" @click="goPage('find-careers')" v-if="!skipCareers">我要入驻</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dark-bg g-flex g-row-center g-font-12">
      <p>Copyright © 2022 蒙自吉祥综合服务平台 滇ICP备14013441号-5 滇ICP证150923号京网文[2020]0399-066 号</p>
      <p class="g-m-l-40">技术支持：云南来可云信息技术有限公司</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "foot-bar",
  data () {
    return {
      //
    }
  },
  computed: {
	  getLoginState() {
	  	return this.$store.state.isLogin
	  },
	skipCareers(){
		return !this.$store.state.isLogin||!this.$store.state.userInfo.clinic_id||this.$store.state.userInfo.clinic_id==-1;
	},
	isClinic(){
		return this.$store.state.isLogin&&(this.$store.state.userInfo.clinic_id!=''&&this.$store.state.userInfo.clinic_id!=-1)
	},
	isCustomer(){
		return this.$store.state.isLogin&&(this.$store.state.userInfo.clinic_id==''||this.$store.state.userInfo.clinic_id==-1)
	}
  },
  methods:{
    goPage(name,val){
      this.$router.push({
        name: name,
        query:val
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
    z-index: 99;
  }

  .logo-icon{
    width: 180px;
    height: 60px;
  }

  .white-bg{
    background: #fff;
  }

  .foot-ico{
    width: 19px;
    height: 19px;
  }

  .dark-bg{
    color: #fff;
    height: 50px;
    background: #000;
  }
</style>
